import { http } from '@/http'
import { imgServe } from '@/imageServe'

const PATH = 'app/'

class ExtinguisherService {
  // noticias
  static async getNotices () {
    return http.get(PATH.concat('all-notices'))
  }

  static async registerNotice (data) {
    return http.post(PATH.concat('upsert-notice'), data)
  }

  static async dataByNoticeId (id) {
    return http.get(PATH.concat('notice-by/').concat(id))
  }

  static async removeByNoticeId (id) {
    return http.delete(PATH.concat('remove-notice/').concat(id))
  }

  // setores
  static async getSectors () {
    return http.get(PATH.concat('sectors'))
  }

  static async allExtinguishersBySector (sectorId) {
    return http.get(PATH.concat('itens/').concat(sectorId))
  }

  static async register (data) {
    return http.post(PATH.concat('sectors/new'), data)
  }

  static async dataBySectorId (id) {
    return http.get(PATH.concat('sectors/').concat(id))
  }

  static async editDataSector (id, data) {
    return http.post(PATH.concat('sectors/edit/').concat(id), data)
  }

  static async removeSector (id) {
    return http.delete(PATH.concat('sectors/').concat(id).concat('/delete'))
  }

  // itens
  static async registerItem (sectorId, data) {
    const headers = {
      headers: {
        __sector_id: sectorId
      }
    }

    return http.post(PATH.concat('itens/new'), data, headers)
  }

  static async getItenById (itemId) {
    return http.get(PATH.concat('itens/by/').concat(itemId))
  }

  static async editItem (itemId, data) {
    return http.post(PATH.concat('itens/edit/').concat(itemId), data)
  }

  static async removeItem (id, sectorId) {
    const headers = {
      headers: {
        __sector_id: sectorId
      }
    }

    return http.delete(PATH.concat('itens/').concat(id).concat('/delete'), headers)
  }

  static async exportToExcel (id) {
    return http.get(PATH.concat('itens/').concat(id).concat('/export-excel'))
  }

  // manutenções

  static async getMaintenancesByItemId (itemId) {
    return http.get(PATH.concat('itens/by/').concat(itemId))
  }

  static async newMaintenanceByItem (itemId, data) {
    const headers = {
      headers: {
        __item_id: itemId
      }
    }

    return http.post(PATH.concat('maintenances/new'), data, headers)
  }

  static async removeMaintenance (id, itemId) {
    const headers = {
      headers: {
        __item_id: itemId
      }
    }

    return http.delete(PATH.concat('maintenances/').concat(id).concat('/delete'), headers)
  }

  // fluxo da imagem

  static async saveImage (newImg) {
    const headers = {
      headers: {
        BASE_PATH: process.env.VUE_APP_BASE_API_URL,
        __company: localStorage.getItem('__company')
      }
    }

    return imgServe.post('new-file', { file: newImg }, headers)
  }

  static async editImage (newImg, imgPath) {
    const headers = {
      headers: {
        BASE_PATH: process.env.VUE_APP_BASE_API_URL,
        __company: localStorage.getItem('__company'),
        __company_path: imgPath
      }
    }

    return imgServe.post('replace-file', { file: newImg }, headers)
  }
}

export default ExtinguisherService
export { PATH }
